import {
  BatterSingleSessionPitchLocationChartConfigDto,
  BatterSingleSessionReportChartConfigDto,
  PitchLocationGrouping,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const BatterSingleSessionPitchLocationChartSidebar = ({
  extraChartData,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<BatterSingleSessionPitchLocationChartConfigDto, BatterSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('BatterSingleSessionPitchLocationChart', extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['GroupOrType', 'PitchCall'] satisfies PitchLocationGrouping[]}
        selected={extraChartData.pitchLocationGrouping}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            batterSingleSessionPitchLocationChartConfig: {
              ...tempLayout.batterSingleSessionPitchLocationChartConfig,
              pitchLocationGrouping: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default BatterSingleSessionPitchLocationChartSidebar;
